import { roleSchema } from "@/features/dashboard/types/user";
import { z } from "zod";

export const caseMemberSchema = z.object({
	id: z.string().optional(),
	case_id: z.string().optional(),
	role: z.string().optional(),
	email: z.string(),
	first_name: z.string(),
	middle_name: z.string().optional(),
	last_name: z.string(),
	suffix: z.string().optional(),
	roles: z.array(roleSchema),
	sex: z.string().optional(),
	birthdate: z.string().optional(),
	birthplace: z.string().optional(),
	region_code: z.string().optional(),
	province_code: z.string().optional(),
	city_code: z.string().optional(),
	barangay: z.string().optional(),
	address_1: z.string().optional(),
	address_2: z.string().optional(),
	zipcode: z.union([z.string(), z.number()]).nullable().optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
	case_record_id: z.string().optional().nullable(),
});

export type CaseMember = z.infer<typeof caseMemberSchema>;
